import { render, staticRenderFns } from "./EditableDateField.vue?vue&type=template&id=9fbecddc"
import script from "./EditableDateField.vue?vue&type=script&lang=js"
export * from "./EditableDateField.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports